import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { productTypes } from '../../../../types/products';

import { TranslatedCopy } from '../../../../intl';
import { H2, H3, Icon, Button } from '../../../../components';

import OrderReturnsPageProduct from '../OrderReturnsPageProduct';

const OrderReturnsPageSubmitted = ({
  returnData,
  products,
  // downloadHandler,
  printHandler,
  getReturnData,
  currencyCode,
  submittedReturnDetails
}) => {
  const {
    accountName,
    name,
    phone,
    email,
    address: { attention, addressLine1, addressLine2, streetAddressLine1, city, state, zipCode }
  } = returnData;
  const paddingRules = 'prl7-sm prl12-md pt7-sm pb7-sm';
  return (
    <div className='orderReturns__submitted'>
      <div className={`orderReturns__submitted_header flex-container end u-full-width bg-white ${paddingRules}`}>
        <ul className='flex-container'>
          {/* Button to be reimplemented once download ability properly developed */}
          {/* <Button
            type='button'
            aria-label={new TranslatedCopy({ id: 'orderreturns.report.download' }).toString()}
            className='mr3-sm'
            onClick={downloadHandler}
            data-desc='download__button'
          >
            <Icon name='download' alt={new TranslatedCopy({ id: 'orderreturns.report.download' }).toString()} />
          </Button> */}
          <Button
            type='button'
            aria-label={new TranslatedCopy({ id: 'orderreturns.report.print' }).toString()}
            className='print__button'
            onClick={printHandler}
            data-desc='print__button'
          >
            <Icon name='print' alt={new TranslatedCopy({ id: 'orderreturns.report.print' }).toString()} />
          </Button>
        </ul>
      </div>
      <div className={`orderReturns__submitted_info flex-container column start bg-white mt-7-sm ${paddingRules}`}>
        <H2 className='mb5-sm'>
          <TranslatedCopy id='global.shipping.info' />
        </H2>
        <div
          className={classnames(
            'orderReturns__submitted_infoInner',
            'flex-container column start bg-gameday-grey-two u-full-width p7-sm'
          )}
        >
          <div className='pb7-sm pb0-lg pr7-lg u-full-width'>
            <H3 className='mb2-sm'>{accountName}</H3>
            {attention && attention.replace(/\s/g, '') !== '' && (
              <p>
                <TranslatedCopy id='global.attn.abbr' />
                {': '}
                {attention}
              </p>
            )}
            <p>{addressLine1}</p>
            <p>{addressLine2}</p>
            <p>{streetAddressLine1}</p>
            <p>
              {city}
              {', '}
              {state} {zipCode}
            </p>
          </div>
          <div>
            <ul>
              <li>
                <H3>
                  <TranslatedCopy id='global.form.contactName' />
                </H3>
                <p>{name}</p>
              </li>
              <li>
                <H3>
                  <TranslatedCopy id='global.form.phone' />
                </H3>
                <p>{phone}</p>
              </li>
              <li>
                <H3>
                  <TranslatedCopy id='global.form.email' />
                </H3>
                <p>{email}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        {submittedReturnDetails.map(({ warehouseAddress, productToReturn }) => (
          <>
            {warehouseAddress && (
              <div
                className={`orderReturns__submitted_info flex-container column start bg-white mt-7-sm ${paddingRules}`}
              >
                <H2 className='mb5-sm'>
                  <TranslatedCopy id='orderreturns.submitted.returnAddress' />
                </H2>
                <div
                  className={classnames(
                    'orderReturns__submitted_infoInner',
                    'flex-container column start bg-gameday-grey-two u-full-width p7-sm'
                  )}
                >
                  <div className='pb7-sm pb0-lg pr7-lg u-full-width'>
                    <H3 className='mb2-sm'>{warehouseAddress.name}</H3>
                    <p>{warehouseAddress.addressLine1}</p>
                    <p>{warehouseAddress.addressLine2}</p>
                    <p>
                      {warehouseAddress.city}
                      {', '}
                      {warehouseAddress.state} {warehouseAddress.zipCode}
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className='orderReturns__submitted_products'>
              {products
                .filter(p1 => productToReturn.find(p2 => p2.productCode === p1.productCode))
                ?.map(product => (
                  <OrderReturnsPageProduct
                    key={product.productCode}
                    product={product}
                    returnableData={getReturnData(product.productCode)}
                    submittedData={returnData}
                    currencyCode={currencyCode}
                    embedded
                    displayOnly
                    submittableReturnsList={productToReturn}
                  />
                ))}
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

OrderReturnsPageSubmitted.propTypes = {
  returnData: PropTypes.shape({
    accountName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    address: PropTypes.shape({
      attention: PropTypes.string.isRequired,
      addressLine1: PropTypes.string.isRequired,
      addressLine2: PropTypes.string.isRequired,
      streetAddressLine1: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  products: PropTypes.arrayOf(productTypes).isRequired,
  // downloadHandler: PropTypes.func.isRequired,
  printHandler: PropTypes.func.isRequired,
  getReturnData: PropTypes.func.isRequired,
  currencyCode: PropTypes.string,
  submittedReturnDetails: PropTypes.array
  // submittableReturnsList: PropTypes.array.isRequired
};

OrderReturnsPageSubmitted.defaultProps = {
  currencyCode: null,
  submittedReturnDetails: []
};

export default OrderReturnsPageSubmitted;
